import React from 'react'
import {Link} from 'react-router-dom'

import {ContactInfo} from '../components/'

const Contact = () => (
    <div className="container contact-page ">
        <div className="row contact">
            <div className="col-sm-12 col-md-6 contact-title">Kontakt</div>
            <div className="col-sm-12 col-md-6 contact-text">
                Trenutno ste tukaj:{' '}
                <Link className="breadcrumbs-link" to="/">
                    Domov
                </Link>{' '}
                <i className="fas fa-angle-right breadcrumbs-icon" /> Kontakt
            </div>
        </div>
        <div className="row clearfix">
            <div className="col-sm-12 col-md-4 contact-details">
                <ContactInfo />
            </div>
            <div className="col-sm-12 col-md-8 contact-map clearfix">
                <h4>Kje smo</h4>
                <div>
                    <iframe
                        className="google-maps"
                        title="map"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2738.465950579165!2d16.25632336589556!3d46.657061129133126!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xca39e67ea77b741e!2sRo%C5%BEa+vetrov%2C+Nautika%2C+ra%C4%8Dunalni%C5%A1tvo%2C+storitve+in+trgovina%2C+d.o.o.!5e0!3m2!1sen!2ssi!4v1529312908602"
                        frameBorder={0}
                        style={{border: 0}}
                        allowFullScreen
                    />
                </div>
            </div>
        </div>
    </div>
)

export default Contact



// WEBPACK FOOTER //
// ./src/components/Contact.js